// Styles
import styles from './index.module.scss'

// Interfaces
import { IUnitCompetencyITem } from './interfaces'

// Components
import { BaseLabel, BaseImage } from 'components'

// Mobx
import { observer } from 'mobx-react'

// Antd
import { Button, Typography } from 'antd'

// i18n
import { useTranslation } from 'react-i18next'

const UnitCompetencyItem = observer(
  ({
    competencyUnit: { competencyUnitName, competentSummary, incompetentSummary, totalCompetency, finishedCompetency },
    onDetailClick,
  }: IUnitCompetencyITem) => {
    // Hook
    const { t } = useTranslation()

    return (
      <div className={`${styles.wrapper} grid grid-cols-3 w-full items-center`}>
        {/* Name */}
        <div className="flex flex-col">
          <Typography.Paragraph
            className="text-grey-font font-16 font-weight-700 leading-6"
            ellipsis={{ tooltip: competencyUnitName }}
            style={{ marginBottom: 5 }}
          >
            {competencyUnitName}
          </Typography.Paragraph>
          <BaseLabel
            label={`Summary: ${competentSummary} Kompeten, ${incompetentSummary} Belum Kompeten`}
            className="text-grey-font font-14 font-weight-400"
          />
        </div>

        {/* Status */}
        <div className="flex flex-col items-center">
          <BaseImage
            icon={totalCompetency === finishedCompetency ? 'check-active' : 'check'}
            isIcon
            width={'35px'}
            height={'35px'}
          />
        </div>

        {/* Action */}
        <div className="flex flex-col items-center">
          <Button className="custom-button common" type="primary" onClick={onDetailClick} ghost>
            <div className="flex items-center gap-3">
              <BaseImage icon={'eye-active'} isIcon />
              <BaseLabel label={t('app.detail')} className="font-16 font-weight-700 text-primary" />
            </div>
          </Button>
        </div>
      </div>
    )
  },
)

export { UnitCompetencyItem }
